import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

const topIds = [4, 2, 6, 12, 14];
const highlight = comics.find((c) => c.id === 4) ?? comics[0];
const rest = topIds.filter((id) => id !== highlight.id).map((id) => comics.find((c) => c.id === id)!).filter(Boolean);

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-100 border-y border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-sm font-medium text-primary-600 tracking-widest">RANKING</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              人气热榜 TOP5
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <Link
            to={`/detail/${highlight.id}`}
            className="lg:col-span-2 group relative rounded-2xl overflow-hidden aspect-[4/5] lg:aspect-auto lg:min-h-[520px] bg-background-200"
          >
            <img
              src={highlight.cover}
              alt={`${highlight.title}热门漫画`}
              title={`${highlight.title} ${highlight.genre}漫画`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
            <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-sm font-bold">
              No.1
            </span>
            <div className="absolute bottom-0 inset-x-0 p-5">
              <div className="flex items-center gap-2">
                <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs">{highlight.genre}</span>
                <span className="px-2 py-0.5 rounded-full bg-background-950/60 text-background-50 text-xs">{highlight.status}</span>
              </div>
              <h3 className="mt-2 font-heading font-bold text-2xl text-background-50">{highlight.title}</h3>
              <p className="mt-2 text-background-100/80 text-sm line-clamp-2">{highlight.intro}</p>
              <div className="mt-3 flex items-center gap-4 text-background-100 text-xs">
                <span><i className="ri-fire-line mr-1 text-accent-300"></i>{highlight.views}</span>
                <span><i className="ri-star-fill mr-1 text-accent-400"></i>{highlight.score.toFixed(1)}</span>
                <span><i className="ri-heart-line mr-1"></i>{highlight.likes.toLocaleString()} 收藏</span>
              </div>
            </div>
          </Link>

          <div className="lg:col-span-3 flex flex-col gap-3">
            {rest.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/detail/${comic.id}`}
                className="group flex items-center gap-4 rounded-xl bg-background-50 p-3 border border-background-200/60 hover:border-primary-200 transition-colors"
              >
                <span className="font-heading font-black text-2xl w-10 text-center text-secondary-300 group-hover:text-primary-500 transition-colors">
                  {idx + 2}
                </span>
                <img
                  src={comic.cover}
                  alt={`${comic.title}封面`}
                  title={`${comic.title} ${comic.genre}漫画`}
                  className="w-14 h-16 md:w-16 md:h-20 rounded-lg object-cover object-top"
                />
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-700 line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{comic.intro}</p>
                  <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800">{comic.genre}</span>
                    <span><i className="ri-fire-line mr-1 text-primary-500"></i>{comic.views}</span>
                    <span><i className="ri-star-fill mr-1 text-accent-500"></i>{comic.score.toFixed(1)}</span>
                  </div>
                </div>
                <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition-all"></i>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}